<div class="dashboard">
  <div class="p-grid dashboard-grid">
    <div class="p-col-12 p-lg-12 pageheader">
      <div class="pagehd">Administration</div>
    </div>

    <div
      class="p-col-12 p-sm-6 p-xl-3 overview-box total-views"
      [routerLink]="['/private-workshop-access-lists']">
      <div class="card text-center hover-over">
        <div>
          <img
            class="img-align"
            src="../../../../assets/icons/nomination_icon.svg"
            alt="" />
        </div>
        <div class="card-title">Private Workshop Access Lists</div>
        <p class="pl-3 mb-2 pr-3 pt-1 ms-fontSize-m text-align">
          Manage private workshop access lists
        </p>
      </div>
    </div>

    <div
      class="p-col-12 p-sm-6 p-xl-3 overview-box total-views"
      [routerLink]="['/notification-banner']">
      <div class="card text-center hover-over">
        <div>
          <img
            class="img-align"
            src="../../../../assets/icons/nomination_icon.svg"
            alt="" />
        </div>
        <div class="card-title">Notification Banner Configuration</div>
        <p class="pl-3 mb-2 pr-3 pt-1 ms-fontSize-m text-align">
          Manage notification banners
        </p>
      </div>
    </div>

    <div
      class="p-col-12 p-sm-6 p-xl-3 overview-box total-views"
      [routerLink]="['/marketing-banner']">
      <div class="card text-center hover-over">
        <div>
          <img
            class="img-align"
            src="../../../../assets/icons/nomination_icon.svg"
            alt="" />
        </div>
        <div class="card-title">Marketing Message Configuration</div>
        <p class="pl-3 mb-2 pr-3 pt-1 ms-fontSize-m text-align">
          Manage marketing banners
        </p>
      </div>
    </div>

    <div
      class="p-col-12 p-sm-6 p-xl-3 overview-box total-views"
      [routerLink]="['/partner-workshop-access-lists']">
      <div class="card text-center hover-over">
        <div>
          <img
            class="img-align"
            src="../../../../assets/icons/nomination_icon.svg"
            alt="" />
        </div>
        <div class="card-title">MCAP Private Access</div>
        <p class="pl-3 mb-2 pr-3 pt-1 ms-fontSize-m text-align">
          Partner workshop access list
        </p>
      </div>
    </div>

    <div
      class="p-col-12 p-sm-6 p-xl-3 overview-box total-views"
      [routerLink]="['/partner-email-allow-lists']">
      <div class="card text-center hover-over">
        <div>
          <img
            class="img-align"
            src="../../../../assets/icons/nomination_icon.svg"
            alt="" />
        </div>
        <div class="card-title">Partner Email Allow List</div>
        <p class="pl-3 mb-2 pr-3 pt-1 ms-fontSize-m text-align">
          Partner email allow List
        </p>
      </div>
    </div>
    <div
      class="p-col-12 p-sm-6 p-xl-3 overview-box total-views"
      [routerLink]="['/program-agreement-partner-details']">
      <div class="card text-center hover-over">
        <div>
          <img
            class="img-align"
            src="../../../../assets/icons/nomination_icon.svg"
            alt="" />
        </div>
        <div class="card-title">Program Agreement</div>
        <p class="pl-3 mb-2 pr-3 pt-1 ms-fontSize-m text-align">
          Signed agreement partner details
        </p>
      </div>
    </div>
    <div
      class="p-col-12 p-sm-6 p-xl-3 overview-box total-views"
      [routerLink]="['/batch-email']">
      <div class="card text-center hover-over">
        <div>
          <img
            class="img-align"
            src="../../../../assets/icons/nomination_icon.svg"
            alt="" />
        </div>
        <div class="card-title">Email</div>
        <p class="pl-3 mb-2 pr-3 pt-1 ms-fontSize-m text-align">
          Send batch email to partners
        </p>
      </div>
    </div>
  </div>
</div>
